<template>
  <v-layout column fluid>
    <v-flex>
      <HeaderBar>
        <v-icon slot="icon">settings</v-icon>
        Call-in Bonus
        <template slot="buttons">
          <router-link :to="{ name: 'settingsIndex' }">Back to All Settings</router-link>
        </template>
      </HeaderBar>
    </v-flex>

    <v-flex v-if="gettingSettings">
      <v-progress-linear indeterminate>
      </v-progress-linear>
    </v-flex>

    <v-flex v-else>
      <v-layout row justify-center class="mb-2">
        <v-flex shrink class="mr-2">
          <v-text-field
            label="Hours prior to shift"
            @change="setNewHours"
          >
          </v-text-field>
        </v-flex>
        <v-flex shrink class="mr-2">
          <v-text-field
            label="Bonus amount"
            @change="setNewBonusAmount"
          >
          </v-text-field>
        </v-flex>
        <v-btn
          @click="setCallIn({hours: newHours, amount: newBonusAmount})"
          color="success"
          :disabled="changingSettings"
          :loading="changingSettings"
        >
          <v-icon left>
            check
          </v-icon>
          Set All
        </v-btn>
      </v-layout>

      <v-divider />

      <v-layout v-for="dif in difs" :key="dif" row>
        <v-flex class="mb-4">
          <v-layout row align-center class="mb-2">
            <v-flex grow>
              <h2>{{ dif }}</h2>
            </v-flex>
            <v-flex shrink class="mr-2">
              <v-text-field
                label="Hours prior to shift"
                @change="setNewHours"
              >
              </v-text-field>
            </v-flex>
            <v-flex shrink class="mr-2">
              <v-text-field
                label="Bonus amount"
                @change="setNewBonusAmount"
              >
              </v-text-field>
            </v-flex>
            <v-btn
              @click="setCallIn({dif_level: dif, hours: newHours, amount: newBonusAmount})" 
              color="success"
              :disabled="changingSettings"
              :loading="changingSettings"
            >
              <v-icon left>
                check
              </v-icon>
              Set all in Dif
            </v-btn>
          </v-layout>
          <v-layout class="ml-4" v-for="p in positionsInDif(dif)" :key="p" row>
            <v-flex shrink class="mr-2">
              <v-text-field
                :label="p"
                disabled
              >
              </v-text-field>
            </v-flex>
            <v-flex shrink class="mr-2">
              <v-text-field
                label="Hours prior to shift"
                :value="settings[dif][p].hours_prior"
                @change="setNewHours"
              >
              </v-text-field>
            </v-flex>
            <v-flex shrink class="mr-2">
              <v-text-field
                label="Bonus amount"
                :value="settings[dif][p].bonus_amount"
                prefix="$"
                @change="setNewBonusAmount"
              >
              </v-text-field>
            </v-flex>
            <v-btn
              @click="setCallIn({dif_level: dif, position_name: p, hours: newHours, amount: newBonusAmount })"
              color="success"
              :disabled="changingSettings"
              :loading="changingSettings"
            >
              <v-icon>
                check
              </v-icon>
            </v-btn>
          </v-layout>

        <v-divider class="my-4" /> <!-- dif section -->

        </v-flex>

      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapState } from 'vuex'
import settingsApi from '@/api/setting.js'

export default {
  components: {
  },
  computed: {
    ...mapState('userAuth', [
      'user',
    ]),
    orderedSettings: function() {
      return this.settings
    },

    difs: function() {
      return Object.keys(this.settings)
    },

  },
  created () {
    this.setUp()
  },
  watch: {
  },
  data: function () {
    return {
      updatingCallIn: false,
      settings: {},
      gettingSettings: false,
      deletingHoliday: false,
      deletingHolidayId: null,
      creatingHoliday: false,
      holidayDateMenu: false,
      newHolidayDate: this.$moment().format("YYYY-MM-DD"),
      difLevelSettings: {},
      newBonusAmount: 0,
      newHours: 0,
      changingSettings: false,
    }
  },
  methods: {
    positionsInDif(dif) {
      return Object.keys(this.settings[dif])
    },

    setNewBonusAmount(e) {
      this.newBonusAmount = e
    },
    setNewHours(e) {
      this.newHours = e
    },

    setUp () {
      this.getCallInSettings()
    },

    setCallIn(setting) {
      this.changingSettings = true
      const difLevel = setting.dif_level
      const position = setting.position_name
      const amount = setting.amount
      const hours = setting.hours

      settingsApi.updateCallIn({
        dif_level: difLevel,
        position_name: position,
        bonus_amount: amount,
        hours_prior: hours
      })
      .then((r) => {
        this.settings = r.data
        this.$store.dispatch('global/showSnackbarSuccess', { message: "Call-in setting changed!" })
      }).finally(() => {
        this.changingSettings = false
      })
    },

    dateFormatted: function (date) {
      return this.$moment(date).format("dddd, MMMM Do YYYY")
    },
    getCallInSettings () {
      this.gettingSettings = true
      settingsApi.getCallIn()
      .then((r) => {
        this.settings = r.data

        // Set up the defaults for the settings at the dif level
        this.difs.forEach((dif) => {
          this.difLevelSettings[dif] = {
            hours_prior: 10,
            bonus_amount: 100,
          }
        })
      })
      .catch(error => {
        console.log(error)
      })
      .finally(r => {
        this.gettingSettings = false
      })
    },
  },
}
</script>

<style scoped>
.holiday-remove {
  visibility: hidden;
  animation: none;
}

.holiday:hover .holiday-remove {
  visibility: visible;
  display: inline-block;
}
</style>
